import type { ErrorEvent, EventHint } from '@sentry/react'

/** Sentry ignoreErrors — 노이즈 필터 정의 */
export const SENTRY_IGNORE_ERRORS: RegExp[] = [
  // axios / 네트워크
  /Request aborted/i,
  /cancel?led/i,
  /AbortError/i,
  /Network Error/i,
  /ERR_NETWORK/i,
  /Failed to fetch/i,
  /Load failed/i,
  /NetworkError when attempting to fetch resource/i,
  /timeout exceeded/i,
  /timeout of \d+ms exceeded/i,
  /ECONNABORTED/i,
  /Request failed with status code 0/i,

  // navigationMonitor
  /SecurityError/i,
  /Blocked a frame with origin/i,
  /Permission denied to access property/i,
  /The operation is insecure/i,

  // CRA 배포 후 chunk 로드 실패
  /Loading (CSS )?chunk/i,
  /ChunkLoadError/i,
  /Importing a module script failed/i,
  /Failed to fetch dynamically imported module/i,

  // reCAPTCHA (RecaptchaJoinFormPage)
  /recaptcha.*timeout/i,
  /Could not connect to the reCAPTCHA service/i,

  // 서드파티 / 확장 프로그램 / cross-origin 스크립트
  /Script error\.?$/i,
  /Object captured as promise rejection/i,
  /Non-Error promise rejection captured/i,
  /NotSupportedError/i,
  /Object doesn't support property or method/i,
  /viewport is not defined/i,

  // 모바일 WebView (BillLetter / 인앱 브라우저)
  /Java object is gone/i,
  /Unable to open URL/i,
  /webkit\??\.messageHandlers/i,
  /messageHandlers\.nativeHandler/i,
  /window\.webkit\.messageHandlers/i,
  /vid_mate_check/i,
  /fb_xd_fragment/,
  /top\.GLOBALS/,

  // 파싱·문법 노이즈
  /Unexpected token/,
  /Unexpected end of input/,
  /Unexpected identifier/,
  /has already been declared/,

  // 브라우저 렌더링
  /ResizeObserver loop/i,
  /NotFoundError/i,
  /removeChild/i,

  // 기타
  /Internal error/i,
]

export const SENTRY_DENY_URLS: (string | RegExp)[] = []

/** 무의미한 네트워크 에러 (사용자 인터넷 끊김) */
export const isOfflineError = (hint?: EventHint): boolean => {
  const err = hint?.originalException
  if (!err || typeof err !== 'object') return false
  return !navigator.onLine || ('code' in err && (err as { code?: string }).code === 'ERR_NETWORK')
}

/** 인앱·광고 WebView 노이즈 (스택에 우리 번들이 없으면 drop) */
export const isInAppWebViewNoise = (event: ErrorEvent): boolean => {
  const frames = event.exception?.values?.[0]?.stacktrace?.frames ?? []

  if (frames.length === 0) return true

  const hasOurCode = frames.some(
    (f) => f.filename?.includes('/static/js/') || f.filename?.includes('webpack'),
  )

  return !hasOurCode
}
